import request from '@/utils/request'
import {uuid} from 'vue-uuid'

export function cardListCustomer(uid1, uid2){ // uid1=member_code uid2 plus_id
  return request({
    url: `/api/cards/list/customer/${uid1}/${uid2}`,
    method: "get"
  });
}

export function cardListBankholder(bankholder_id){
  return request({
    url: `/api/cards/list/${bankholder_id}`,
    method: "get"
  });
}

export function getPin(card_id){
  return request({
    url: `/api/cards/${card_id}/pin/get`,
    method: "get"
  });
}

export function cardPicture(card_id){
  return request({
    url: `/api/cards/${card_id}/picture`,
    method: "get"
  });
}

export function cardIssue(data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/cards/issue`,
    method: "post",
    data: data
  });
}

export function resetPin(card_id, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/cards/${card_id}/pin/reset`,
    method: "post",
    data: data
  });
}

export function cardActivate(card_id, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/cards/${card_id}/activate`,
    method: "post",
    data: data
  });
}

export function cardStatus(card_id, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/cards/${card_id}/status`,
    method: "post",
    data: data
  });
}

export function cardReplace(card_id, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/cards/${card_id}/replace`,
    method: "post",
    data: data
  });
}